import { useCheckoutContext } from "../../Checkout.hooks";
import { checkoutStore } from "../../Checkout.store";
import { WalleyPaymentType } from "../../Checkout.types";

export default function WalleyCustomerPicker() {
  const paymentType = checkoutStore((state) => state.paymentType);
  const setPaymentType = checkoutStore((state) => state.setPaymentType);
  const { dictionary } = useCheckoutContext();
  return (
    <div className="mx-auto grid w-full max-w-120 grid-flow-col justify-stretch justify-self-center border">
      <button
        className="bg-gray-100 px-4 py-2 data-active:bg-black data-active:text-white"
        onClick={() => setPaymentType(WalleyPaymentType.b2c)}
        data-active={paymentType === WalleyPaymentType.b2c}
      >
        {dictionary.individual}
      </button>
      <button
        className="bg-gray-100 px-4 py-2 data-active:bg-black data-active:text-white"
        onClick={() => setPaymentType(WalleyPaymentType.b2b)}
        data-active={paymentType === WalleyPaymentType.b2b}
      >
        {dictionary.company}
      </button>
    </div>
  );
}
